<template>
	<div>
		<!-- <navTitle><div class="pageTitle">我的收藏</div></navTitle> -->
		<div class="applyTop">
			<div class="flex flex-align-center flex-jus-between">
				<img src="@/static/images/icon-arrowLeft.png" class="arrow" @click="goBack" />
				<img src="@/static/images/icon-my.png" class="arrow" @click="$router.push({ name: 'my' })" />
			</div>
		</div>

		<div class="homePage">
			<div @click="openImg" class="avatar flex flex-align-center flex-jus-center"><img :src="detail.avatar" alt="" /></div>

			<div class="homePage-my flex flex-align-center flex-jus-between">
				<div class="homePage-my-name">{{detail.nickname}}</div>
				<div @click="$router.push('/my/watch?name=watch')" class="homePage-my-attetion flex flex-column flex-align-center">
					<div>{{detail.concern_number}}</div>
					<div style="color: #818181;margin-top: 2px;">关注</div>
				</div>

				<div @click="$router.push('/my/watch?name=fans')" class="homePage-my-attetion flex flex-column flex-align-center">
					<div>{{detail.fans_number}}</div>
					<div style="color: #818181;margin-top: 2px;">粉丝</div>
				</div>
				<div v-if="user_id!=localUser_id">
					<div @click="focus" v-if="detail.is_follow == 0" class="homePage-my-btn attentionBtn-yes"></div>
					<div @click="focus" v-if="detail.is_follow == 1" class="homePage-my-btn attentionBtn-no"></div>
				</div>
				<div v-else style="width: 66px">

				</div>
			</div>
			<div class="introduce">
				{{ bio ? bio : '暂无简介~'}}
				<img v-if="localUser_id == user_id" @click="bioText = bio;showEdit = true" class="edit" src="../../../static/images/edit.png"/>
			</div>

			<div class="homePage-line"></div>

			<van-list>
				
			</van-list>
			<div class="friendsList">
				<van-list
					v-model="loading"	
					:finished="finished"
					:immediate-check="false"
					finished-text="没有更多了"
					@load="onLoad"
					:offset="10"
				>
					<div v-for="item in dataList" :key="item.id" class="friendsItem flex">
						<img :src="item.avatar" class="friendsList-avatar" />
						<div class="right flex-1 flex flex-column">
							<div class="name flex flex-align-center flex-jus-between">
								<div>{{item.nickname}}</div>
								<div @click="doLikes(item.id)" class="name-good flex flex-align-center">
									<img v-if="item.is_likes == 1"  src="../../../static/images/index/good_yes.png" />
									<img v-else src="../../../static/images/index/good.png" />
									<div style="margin-top: 1px;">{{item.likes_num}}</div>
								</div>
							</div>
							<div class="time">{{item.time}}</div>
							<div class="content">{{item.brief}}</div>
							<div v-if="item.type == 2" class="imgList flex flex-align-center flex-jus-between flex-wrap">
								<videoItem
									:cover="item.pic"
									:content="''"
									:width="167"
									:height="111"
									:videoSrc="item.content"
								></videoItem>
							</div>
							<div v-if="item.type == 1" class="imgList flex flex-align-center flex-jus-between flex-wrap">
								<img @click.stop="openImg1(item.content, cIndex)" v-for="(cItem, cIndex) in item.content" :key="cIndex" :src="cItem" alt="" />
							</div>
						</div>
					</div>
				</van-list>
			</div>
		</div>
		<van-image-preview v-model="showImg" :images="imagesArr">
    </van-image-preview>
		<van-image-preview v-model="showImg1" :images="imagesArr1" :startPosition="startPosition">
    </van-image-preview>
		<van-popup v-model="showEdit" round >
			<div class="editBox">
				<div class="title">编辑简介</div>
				<img @click="showEdit = false" class="close" src="../../../static/images/index/close.png">
				<div class="content">
					<textarea v-model="bioText" maxlength="100" placeholder="请输入简介..." />
					<div class="length">{{bioText.length}}/100</div>
				</div>
				<div @click="confirm" class="confirm">
					确定
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import videoItem from '@/views/components/videoItem.vue';
/* eslint-disable */
export default {
	components: {
		videoItem
	},
	data() {
		return {
			userInfo: {},
			bio: '',
			bioText: '',
			showEdit: false,
			localUser_id: '',
			user_id: '',
			page: 1,
			pageSize: 10,
			detail: {},
			dataList: [],
			loading: false,
      finished: false,

			showImg: false,
			imagesArr: [],
			showImg1: false,
			imagesArr1: [],
			startPosition: 0
		};
	},
	created() {
		this.user_id = this.$route.query.id || localStorage.getItem('user_id')
		this.localUser_id = localStorage.getItem('user_id')
		this.getList()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '个人主页',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		confirm() {
			this.userInfo.bio = this.bioText
			this.$post('api/user/userUpdate', this.userInfo).then(res => {
				this.showEdit = false
				this.bio = this.bioText
				this.$toast('保存成功')
			})
		},
		goBack() {
			if (window.history.length <=1 ) {
				this.$router.push('/home')
			} else {
				this.$router.back(-1)
			}
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
		getList() {
			this.$get('api/user/getPersonalHomepage', {
				user_id: this.user_id || this.localUser_id,
				page: this.page,
				pageSize: this.pageSize
			}).then(res => {
				this.detail = res.data
				this.bio = res.data.bio
				this.loading = false;
        let rows = res.data.circle_list;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.dataList = this.dataList.concat(rows);
			})
		},
		focus() {
			this.$post('api/circle/userFollow', {to_id: this.user_id}).then(() => {
				if (this.detail.is_follow == 1) {
					this.$toast('已取关')
					this.detail.is_follow = 0
				} else {
					this.$toast('关注成功')
					this.detail.is_follow = 1
				}
			})
		},
		openImg() {
			this.imagesArr = [this.detail.avatar]
			this.showImg = true
		},
		doLikes(id) {
      let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
        return
			}
			this.$post('api/actile/doLikes', {
				type: 2,
				article_id: id
			}).then(() => {
				this.page = 1
				this.dataList = []
				this.getList()
      })
		},
		openImg1(data, index) {
			this.imagesArr1 = data
			this.showImg1 = true
			this.startPosition = index
		}
	}
};
</script>

<style scoped lang="stylus">
.applyTop
	background-image url('~@/static/images/my/applyBG.png')
	background-size 100% 100%
	background-position center
	width 100vw
	height 260px
	padding 24px 30px
	.arrow
		width 52px
		height 52px
.homePage
	width 100%
	min-height calc(100vh - 322px)
	background #FFFFFF
	border-radius 40px 40px 0px 0px
	padding 44px 30px
	margin-top -78px
	position relative
	.introduce
		margin 26px 24px 0
		font-size 24px
		line-height 44px
		color #404040
		position relative
	.edit
		position absolute
		right 14px
		bottom -28px
		width 28px
		height 28px
	.homePage-line
		margin-top 40px
		width 100%
		height 2px
		background #E6E6E6
	.avatar
		position absolute
		left 30px
		top -64px
		width 136px
		height 136px
		background-image url('~@/static/images/my/avatarBG.png')
		background-size 100% 100%
		background-position center
		img
			width 100px
			height 100px
			border-radius 50%
	.homePage-my
		.homePage-my-name
			align-self flex-end
			margin-left 20px
			font-size 32px
			font-weight 800
			color #000000
		.homePage-my-attetion
			// margin-left 120px
			font-size 28px
			color #050505
		.homePage-my-btn
			width 132px
			height 54px
			background-size 100% 100%
			background-position center
			// margin-left 60px
		.attentionBtn-yes
			background-image url('~@/static/images/my/attention_yes.png')
		.attentionBtn-no
			background-image url('~@/static/images/my/attention_no.png')
	.friendsList
		// margin-top 94px
		padding 0 30px
		.friendsItem
			padding-top 44px
			.friendsList-avatar
				width 84px
				height 84px
				border-radius 50%
			.name
				width 100%
				font-size 28px
				font-weight bold
				color #000000
				.name-good
					font-size: 26px;
					color: #000000;
					img
						width 32px
						height 32px
						margin-right 8px
			.time
				width 100%
				margin-top 8px
				font-size 22px
				color #979797
			.content
				margin-top 24px
				margin-bottom 28px
				width 100%
				font-size 26px
				color #000000
			.imgList
				margin-bottom 40px
				img
					width 170px
					height 170px
					object-fit cover
					border-radius 20px
					margin-bottom 10px
			.imgList:after
				content ''
				display inline-block
				width 170px
			.right
				margin-left 24px
				border-bottom 2px solid #ECECEC
			.infoStatus
				margin-top 40px
				margin-bottom 40px
				font-size 26px
				color #000000
				.icon
					width 32px
					height 32px
					margin-right 8px
.editBox
	width 634px
	height 550px
	border-radius 24px
	background #fff
	padding-top 40px
	position relative
	overflow hidden
	.title
		text-align center
		font-size 36px
		line-height 50px
		font-weight bold
		margin-bottom 40px
	.close
		width 48px
		height 48px
		position absolute
		top 42px
		right 24px
	.content
		width 586px
		height 248px
		border-radius 20px
		background #f7f7f7
		padding 24px
		margin 0 auto 40px
		position relative
		.length
			position absolute
			bottom 24px
			right 24px
			font-size 24px
	.confirm
		width 376px
		height 92px
		background url('../../../static/images/index/btnBG.png')
		background-size 100% 100%
		font-size 32px
		color #fff
		line-height 92px
		text-align center
		margin 0 auto
	textarea{
		width 538px
		height 200px;
		border:none;
		outline: none;
		resize: none;
		background #f7f7f7
		font-size 24px
	}
</style>
